import {Routes} from '@angular/router';
import {AuthenticatedGuard} from './guards/authenticated.guard';
import { ConfigReadyGuard } from './guards/config-ready.guard';

export const APP_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'listeClients',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/connexion/connexion.module').then(m => m.ConnexionModule),
    canActivate: [ConfigReadyGuard]
  },
  {
    path: 'listeClients',
    loadChildren: () => import('./pages/liste-clients/liste-clients.module').then(m => m.ListeClientsModule),
    canActivate: [ConfigReadyGuard, AuthenticatedGuard]
  },
  {
    path: 'synchros',
    loadChildren: () => import('./pages/synchros/synchros.module').then(m => m.SynchrosModule),
    canActivate: [ConfigReadyGuard, AuthenticatedGuard]
  },
  {
    path: 'editionClient',
    loadChildren: () => import('./pages/edition-client/edition-client.module').then(m => m.EditionClientModule),
    canActivate: [ConfigReadyGuard, AuthenticatedGuard]
  },
  {
    path: 'version-infos',
    loadChildren: () => import('./pages/version-infos/version-infos.module').then(m => m.VersionInfosModule),
    canActivate: [ConfigReadyGuard, AuthenticatedGuard]
  },
];
